import { queryOptions } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import { keys } from '@/lib/query-keys';

/*
 * Session query options (spec §3.10). Short stale time bounds how long revoked
 * access lingers in the cache. The _auth gate primes this on cold arrival.
 */
export const sessionQueryOptions = queryOptions({
  queryKey: keys.session.me(),
  queryFn: () => api.auth.me(),
  staleTime: 30_000,
  retry: false,
});
